import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDownIcon } from 'lucide-react';
import { HERO_IMAGE, CITIES, OCCASIONS } from '../../data/smaken';
import { UnderlineMark, Note, ArrowMark } from '../Marks';
import { DoingWords } from './DoingWords';
const AREAS = ['Hela Småland', ...Object.keys(CITIES)];
export function Hero() {
  const navigate = useNavigate();
  const [occasion, setOccasion] = useState('');
  const [date, setDate] = useState('');
  const [guests, setGuests] = useState('');
  const [area, setArea] = useState(AREAS[0]);
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (occasion) params.set('tillfalle', occasion);
    if (guests) params.set('gaster', guests);
    if (area !== AREAS[0]) params.set('ort', area);
    navigate(params.toString() ? `/catering?${params}` : '/catering');
  };
  const labelClass = 'text-[10px] font-bold uppercase tracking-wide3 text-black/45';
  const fieldClass = 'w-full bg-transparent font-display text-xl outline-none placeholder:text-black/25 sm:text-2xl';
  return <section className="mx-auto max-w-page px-5 pb-10 pt-10 md:px-8 md:pb-16 md:pt-14" data-id="element-529" data-mp="1rx0dns2znk99">
      <div className="grid items-end gap-10 lg:grid-cols-[minmax(0,1.05fr),minmax(0,1fr)] lg:gap-14" data-id="element-530" data-mp="1czgbsu1e257b">
        <div data-id="element-531" data-mp="1hy12a1qu9aik">
          <DoingWords data-id="element-532" data-mp="1hxhvnh6n28ju" />
          <h1 className="display-xl mt-3 text-[3.2rem] uppercase leading-[0.88] sm:text-[4.8rem] lg:text-[5.8rem]" data-id="element-533" data-mp="1hz2nv05hdfej">
            Vad ska ni
            <br data-id="element-534" data-mp="2am6q4xd6vfmm" />
            <span className="relative inline-block" data-id="element-535" data-mp="2aklut5j1vsnp">
              bjuda
              <UnderlineMark className="absolute -bottom-1 left-0 h-3 w-full text-rod sm:-bottom-2 sm:h-4" data-id="element-536" data-mp="1vxsnonjopt6l" />
            </span>{' '}
            på?
          </h1>

          <p className="mt-7 max-w-md text-lg leading-relaxed text-black/70 sm:text-xl" data-id="element-537" data-mp="20tr5ttef6eyk">
            Säg tillfället, så plockar vi ihop det från Smålands bästa bagerier, kök och producenter.{' '}
            <span className="text-black" data-id="element-538" data-mp="2te99igh7ta0k">En förfrågan. Ett svar. En leverans.</span>
          </p>

          {/* Booking form — ruled, not carded */}
          <form onSubmit={submit} className="mt-9 max-w-2xl border-t-2 border-black" data-id="element-539" data-mp="2yadbky7j4opm">
            <div className="grid border-b border-black/15 sm:grid-cols-2" data-id="element-540" data-mp="2u6xg45774uei">
              <div className="relative py-4 sm:pr-6" data-id="element-541" data-mp="2p8m2rkhp01rj">
                <label htmlFor="h-cat" className={labelClass} data-id="element-542" data-mp="2p83z42spal9l">
                  Vad
                </label>
                <select id="h-cat" value={occasion} onChange={e => setOccasion(e.target.value)} className={`${fieldClass} mt-1 cursor-pointer appearance-none pr-6`} data-id="element-543" data-mp="2kau487mjlhed">
                  <option value="" data-id="element-544" data-mp="26ixf8cg67nm7">Hela dagen</option>
                  {OCCASIONS.map(o => <option key={o} data-id="element-545" data-mp="21jb01xgs7xar">{o}</option>)}
                </select>
                <ChevronDownIcon className="pointer-events-none absolute bottom-6 right-2 h-4 w-4 text-black/40 sm:right-6" aria-hidden="true" data-id="element-546" data-mp="1wjey03rnafxu" />
              </div>

              <div className="border-t border-black/15 py-4 sm:border-l sm:border-t-0 sm:pl-6" data-id="element-547" data-mp="gzxtw8134oyf">
                <label htmlFor="h-date" className={labelClass} data-id="element-548" data-mp="m14zq1jo3e2g">
                  När
                </label>
                <input id="h-date" type="date" value={date} onChange={e => setDate(e.target.value)} className={`${fieldClass} mt-1 cursor-pointer`} data-id="element-549" data-mp="q0dun9qg1hzl" />
              </div>
            </div>

            <div className="grid sm:grid-cols-2" data-id="element-550" data-mp="2b1ka6jdr3vp">
              <div className="py-4 sm:pr-6" data-id="element-551" data-mp="72t31uwao5ba">
                <label htmlFor="h-guests" className={labelClass} data-id="element-552" data-mp="73uomtaxsa79">
                  Hur många
                </label>
                <input id="h-guests" type="number" min="1" value={guests} onChange={e => setGuests(e.target.value)} placeholder="25 gäster" className={`${fieldClass} mt-1`} data-id="element-553" data-mp="36pt0e1825x97" />
              </div>

              <div className="relative border-t border-black/15 py-4 sm:border-l sm:border-t-0 sm:pl-6" data-id="element-554" data-mp="31d44gzj8bnmk">
                <label htmlFor="h-area" className={labelClass} data-id="element-555" data-mp="2wmnphazrfty3">
                  Var
                </label>
                <select id="h-area" value={area} onChange={e => setArea(e.target.value)} className={`${fieldClass} mt-1 cursor-pointer appearance-none pr-6`} data-id="element-556" data-mp="3ad9ab58rydym">
                  {AREAS.map(a => <option key={a} data-id="element-557" data-mp="3fd56iib8d13m">{a}</option>)}
                </select>
                <ChevronDownIcon className="pointer-events-none absolute bottom-6 right-2 h-4 w-4 text-black/40" aria-hidden="true" data-id="element-558" data-mp="1pxnue023ltwy" />
              </div>
            </div>

            <button type="submit" className="group mt-5 inline-flex w-full items-center justify-center gap-3 bg-rod px-10 py-4 text-[12px] font-bold uppercase tracking-wide2 text-papper transition-colors duration-150 ease-out hover:bg-black sm:w-auto" data-id="element-559" data-mp="gjyih954gw5">
              Hitta catering
              <ArrowMark className="h-3.5 w-8 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-560" data-mp="3ru6etpistm6d" />
            </button>
          </form>
        </div>

        <figure className="relative" data-id="element-561" data-mp="3hxtg2d8eci4r">
          <img src={HERO_IMAGE} alt="Ett uppdukat bord i Småland med surdegsbröd, ost, blåbär, kanelbullar och kaffe" className="aspect-[4/3] w-full object-cover lg:aspect-[4/4.2]" data-id="element-562" data-mp="3hyuy51nty4vz" />
          <figcaption className="absolute -bottom-4 left-4 flex items-center gap-2 bg-papper py-2 pr-3 sm:-left-6" data-id="element-563" data-mp="38ygavwrb2fpu">
            <ArrowMark className="h-6 w-14 -rotate-12 text-rod" data-id="element-564" data-mp="17509q5xldigm" />
            <Note data-id="element-565" data-mp="1735zbljy58qs">Ni bjuder. Vi fixar resten.</Note>
          </figcaption>
        </figure>
      </div>
    </section>;
}